import React, { useState } from "react";
import Contact from "../Contact/Contact";
import Footer from "../Footer/Footer";
import Landing from "../Landing/Landing";
import Navbar from "../NavBar/Navbar";
import NavbarMenu from "../NavbarMenu/NavbarMenu";
import SideBar from "../SideBar/SideBar";


import fsTopIcon from "../../image/newImg/fs.png";
import "./Content.css";

const staffMembers = [
  {
    srNo: 1,
    name: "DR. AMBIKA PRASAD GAUR",
    designation: "PRINCIPAL",
    qualification: "M.A.(Eng), B.Ed, M.B.A., Ph.D",
  },
  {
    srNo: 2,
    name: "MR. DEENA NATH RAJPUT",
    designation: "HEADMASTER",
    qualification: "M.A.(Eng), B.Ed",
  },
  {
    srNo: 3,
    name: "MS. SUCHITA TIWARI",
    designation: "HEADMISTRESS",
    qualification: "M.A., B.Ed",
  },
  {
    srNo: 4,
    name: "MR. ARUN KUMAR MISHRA",
    designation: "PGT HISTORY",
    qualification: "M.A. B.Ed",
  },
  {
    srNo: 5,
    name: "MS. RADHANA MISHRA",
    designation: "PGT (Hindi)",
    qualification: "B.Ed, Ph.D",
  },
  {
    srNo: 6,
    name: "MR. BASANT LAL VERMA",
    designation: "PGT (CHEMISTRY)",
    qualification: "M.Sc., B.Ed",
  },
  {
    srNo: 7,
    name: "MR. SIDDHARTHA SINGH",
    designation: "PGT ACCOUNTS",
    qualification: "M.Com, B.Ed",
  },
  {
    srNo: 8,
    name: "MR. PRAVEEN KR. DUBEY",
    designation: "PGT (Physics)",
    qualification: "M.Sc, B.Ed",
  },
  {
    srNo: 9,
    name: "MS. AMRITA SHUKLA",
    designation: "PGT ENGLISH",
    qualification: "M.A., B.Ed",
  },
  {
    srNo: 10,
    name: "MR. ARVIND KUMAR",
    designation: "PGT ENGLISH",
    qualification: "M.A., B.Ed",
  },
  {
    srNo: 11,
    name: "MR. TRIYUGI NATH GUPTA",
    designation: "PGT ECONOMICS",
    qualification: "M.A., B.Ed",
  },
  {
    srNo: 12,
    name: "MR. ANUJ KUMAR SINGH",
    designation: "PGT (Computer)",
    qualification: "MCA",
  },
  {
    srNo: 13,
    name: "MR. BHARAT KUSHWAHA",
    designation: "PGT (BIO)",
    qualification: "M.Sc. (BIOTECH), B.Ed",
  },
  {
    srNo: 14,
    name: "MR. RAJEEV PRAKASH SINGH YADAV",
    designation: "PGT POLITICAL SCIENCE",
    qualification: "M.A. B.Ed",
  },
  {
    srNo: 15,
    name: "MR. PRABHAT UPADHYAY",
    designation: "PGT BUSINESS STUDIES",
    qualification: "M.Com, B.Ed",
  },
  {
    srNo: 16,
    name: "MR. MOHIT KUMAR CHAUBEY",
    designation: "PGT (Maths)",
    qualification: "M.Sc (Maths)\nB.Ed",
  },
  {
    srNo: 17,
    name: "MR. KRISHNA KUMAR",
    designation: "PET",
    qualification: "M.P.Ed",
  },
  {
    srNo: 18,
    name: "MR. GHULAM MUSTAFA",
    designation: "PET",
    qualification: "B.PEd., M.P.Ed",
  },
  {
    srNo: 19,
    name: "MS. SHASHI BALA SRIVASTAVA",
    designation: "PET",
    qualification: "B.A., B.P.Ed",
  },
  {
    srNo: 20,
    name: "MR. RAKESH KUMAR SINGH",
    designation: "TGT SCIENCE",
    qualification: "B.Sc, B.Ed",
  },
  {
    srNo: 21,
    name: "MR. RAMESH KR. SRIVASTAVA",
    designation: "TGT ART",
    qualification: "B.A., B.F.A (FINE ART)",
  },
  {
    srNo: 22,
    name: "MR. RAHUL TIWARI",
    designation: "TGT COMPUTER",
    qualification: "BCA, M.Sc. (CS)",
  },
  {
    srNo: 23,
    name: "MR. YOGESH KR. SINGH",
    designation: "TGT MATHS",
    qualification: "M.Sc., B.Ed",
  },
  {
    srNo: 24,
    name: "MR. RANA RAJESH SINGH",
    designation: "TGT MATHS",
    qualification: "M.Sc, B.Ed",
  },
  {
    srNo: 25,
    name: "MR. MANISH BAJPAI",
    designation: "TGT SCIENCE",
    qualification: "M.Sc, B.Ed",
  },
  {
    srNo: 26,
    name: "MR. SHYAMA NAND SINGH",
    designation: "TGT SOCIAL SCIENCE\n(Special Educator)",
    qualification: "M.A., M.Ed",
  },
  {
    srNo: 27,
    name: "MR. AKHILESH KR. SHARMA",
    designation: "TGT SOCIAL SCIENCE",
    qualification: "M.A., B.Ed",
  },
  {
    srNo: 28,
    name: "MR. GAURAV KUMAR",
    designation: "TGT SOCIAL SCIENCE",
    qualification: "M.A., B.Ed",
  },
  {
    srNo: 29,
    name: "DR. POONAM B. VERMA",
    designation: "TGT SANSKRIT",
    qualification: "M.A., M.Phil,\nB.Ed, Ph.D",
  },
  {
    srNo: 30,
    name: "MR. RATAN BAHADUR THAPA",
    designation: "TGT SCIENCE",
    qualification: "M.Sc., B.Ed",
  },
  {
    srNo: 31,
    name: "MR. AMOD DUBEY",
    designation: "TGT MATHS",
    qualification: "M.Sc., B.Ed",
  },
  {
    srNo: 32,
    name: "MS. APARNA RANA",
    designation: "TGT-COUNSELLOR\n/ WELLNESS TEACHER",
    qualification: "M.A.\nCLINICAL PSYCHOLOGY",
  },
  {
    srNo: 33,
    name: "MR. SANDEEP KUMAR RAI",
    designation: "TGT ENGLISH",
    qualification: "M.A. B.Ed",
  },
  {
    srNo: 34,
    name: "MR. DHIRENDRA KUMAR SRIVASTAV",
    designation: "TGT MATHS",
    qualification: "M.Sc, B.Ed",
  },
  {
    srNo: 35,
    name: "MS. VINITA BAJPAI",
    designation: "TGT-HINDI",
    qualification: "M.A., B.Ed",
  },
  {
    srNo: 36,
    name: "MR. PADMESH SINGH YADAV",
    designation: "TGT HINDI",
    qualification: "M.A., B.Ed",
  },
  {
    srNo: 37,
    name: "MS. SHAISTA ROOHI",
    designation: "TGT ENGLISH",
    qualification: "M.A., B.Ed",
  },
  {
    srNo: 38,
    name: "MR. RITESH MISHRA",
    designation: "TGT-ENGLISH",
    qualification: "M.A., B.Ed",
  },
  {
    srNo: 39,
    name: "MS. VANDANA SINGH",
    designation: "TGT-HINDI",
    qualification: "M.A., B.Ed",
  },
  {
    srNo: 40,
    name: "MR. HIMANSHU VISHWAKARMA",
    designation: "TGT-SCIENCE",
    qualification: "B.Sc, B.Ed",
  },
  {
    srNo: 41,
    name: "MS. VEENA SINGH",
    designation: "PRT",
    qualification: "M.A., B.Ed",
  },
  {
    srNo: 42,
    name: "MS. GARIMA RAJ PANDEY",
    designation: "PRT",
    qualification: "BBA, B.Ed",
  },
  {
    srNo: 43,
    name: "MS. SHIFALI SRIVASTAVA",
    designation: "PRT",
    qualification: "M.A., B.Ed",
  },
  {
    srNo: 44,
    name: "MS. ARPITA TIWARI",
    designation: "PRT",
    qualification: "B.A., D.El.Ed",
  },
  {
    srNo: 45,
    name: "MS. RITU SRIVASTAVA",
    designation: "PRT",
    qualification: "B.Sc, B.Ed",
  },
  {
    srNo: 46,
    name: "MS. SUDHA VERMA",
    designation: "PRT",
    qualification: "B.Com, B.Ed",
  },
  {
    srNo: 47,
    name: "MS. KAVITA KHANNA",
    designation: "PRT MUSIC",
    qualification: "M.A., B.MUSIC",
  },
  {
    srNo: 48,
    name: "MS. SHALINI",
    designation: "PRT",
    qualification: "M.A., B.Ed",
  },
  {
    srNo: 49,
    name: "MS. REENA CHAWALA",
    designation: "PRT-COMPUTER",
    qualification: "PGDCA",
  },
  {
    srNo: 50,
    name: "MR. PANKAJ SRIVASTAVA",
    designation: "PRT DANCE",
    qualification: "B.A.,\nPRABHAKAR",
  },
  {
    srNo: 51,
    name: "MR. SUNIL KUMAR",
    designation: "PRT ART & CRAFT",
    qualification: "M.F.A.",
  },
  {
    srNo: 52,
    name: "MS. NIDHI SRIVASTAVA",
    designation: "PRT",
    qualification: "M.A., B.Ed",
  },
  {
    srNo: 53,
    name: "MS. MONIKA GUPTA",
    designation: "KG TEACHER",
    qualification: "B.A., NTT",
  },
  {
    srNo: 54,
    name: "MS. PRIYANKA AGRAWAL",
    designation: "PRT",
    qualification: "B.Com, B.Ed",
  },
  {
    srNo: 55,
    name: "MS. PAROMITA BANERJEE",
    designation: "NURSERY TEACHER",
    qualification: "B.A., NTT (PURSUING B.Ed)",
  },
  {
    srNo: 56,
    name: "MS. MADHULIKA ASTHANA",
    designation: "PRT",
    qualification: "B.A., B.Ed",
  },
  {
    srNo: 57,
    name: "MS. SWASTIKA PRABHAT TIWARI",
    designation: "NTT",
    qualification: "B.Com, M.Com",
  },
];

function Faculty(props) {
  const {
    cover,
    sidebar_data,
    side_heading,
    side_sub_heading,
  } = props;
  const [isScrolled, setIsScrolled] = useState(false);
  const [isShow, steIsShow] = useState(false);
  const handleScroll = (e) => {
    console.log("asd");
    if (e.target.scrollTop > 0 && !isScrolled) {
      setIsScrolled(true);
    }
    if (e.target.scrollTop === 0) {
      setIsScrolled(false);
    }
  };
  const handleClick = () => {
    steIsShow(!isShow);
    console.log(isShow);
  };

  return (
    <div className="content_main" onScroll={handleScroll}>
      <Navbar isScrolled={isScrolled} handleClick={handleClick} />
      <NavbarMenu isShow={isShow} handleClick={handleClick} />
      <Landing video={false} cover={cover} />
      <div className="contentmain_cont">
        <div style={{ width: "min-content" }}>
          <SideBar
            sidebar_data={sidebar_data}
            side_heading={side_heading}
            side_sub_heading={side_sub_heading}
          />
          <Contact />
        </div>
        <div>
          <div className={`f-2 f-500 mb-3`} style={{ color: "#0076BD" }}>
            <img
              src={fsTopIcon}
              style={{ width: "4rem", marginRight: "1rem" }}
              alt=""
            />
            Faculty & Staff
          </div>
          <div>
            <div className="d-flex gap-2 mt-1">
              <div>
                {/* <div className="f-bold f-1-2 mb-2"></div> */}
                <div className="color-grey f-500">
                  School staff and faculty form the backbone of the educational ecosystem, directly shaping student success and operational excellence. While faculty members ignite intellectual curiosity in the classroom, the broader support staff ensures a safe, efficient, and welcoming environment for learning.
                </div> 
                <div className="color-grey f-500 mt-2">
                  HGS Varanasi has a very experienced, knowledgeable, well-qualified and dedicated Staff, so that they are conscious of their responsibility of being the most important block in the foundation of the Nation as well as the Society.
                </div> 
                <div className="color-grey f-500 mt-2">
                  Their self-discipline is an example in itself, which always drives them to work as a well-knit team to make all possible endeavour together for the holistic growth of students as well the institution. They are enthusiastic, dedicated, conscientious and highly motivated to adapt to new innovative ideas and well versed with modern education systems.
                </div>
                <div className="color-grey f-500 mt-2">
                  The valuable contribution of all the Faculty members is well manifested in the spectacular achievements of our students in the scholastic as well as co- scholastic discipline.
                </div> 
                <div className="color-grey f-500 mt-2">
                  The Teachers grouped under various subject-wise Faculties are put under the guidance of the most experienced Faculty heads. All of them always put their heads together to devise improvised methodology to deliver their best to facilitate the young evolving minds. This significantly contributes in promoting the problem solving skills of students to enable them to grow as useful citizens.
                </div>

              </div>
            </div>
          </div>
          <div className="faculty_staff">
            <div className="table-responsive faculty-table-wrap mt-4">
              <table className="table table-bordered table-striped table-hover align-middle faculty-table">
                <thead className=" table-color">
                  <tr>
                    <th scope="col" className="text-center">
                      Sr. No.
                    </th>
                    <th scope="col">Name of The Staff Members</th>
                    <th scope="col">Designation</th>
                    <th scope="col">Qualification</th>
                  </tr>
                </thead>
                <tbody>
                  {staffMembers.map((staff) => (
                    <tr key={staff.srNo}>
                      <th scope="row" className="text-center">
                        {staff.srNo}
                      </th>
                      <td>{staff.name}</td>
                      <td>{staff.designation}</td>
                      <td>{staff.qualification}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Faculty;
